import { Channel as AppChannel } from '@/features/orders/constants/app'
import { Channel as FirebaseChannel } from '@/features/orders/constants/firebase'

export const firebaseToAppChannel: Record<FirebaseChannel, AppChannel> = {
    [FirebaseChannel.Menuboard]: AppChannel.Menuboard,
    [FirebaseChannel.Web]: AppChannel.Web,
    [FirebaseChannel.QR]: AppChannel.QR,
    [FirebaseChannel.Kiosk]: AppChannel.Kiosk,
    [FirebaseChannel.Foodora]: AppChannel.Foodora,
    [FirebaseChannel.Wolt]: AppChannel.Wolt,
    [FirebaseChannel.Pos]: AppChannel.Pos,
    [FirebaseChannel.Phone]: AppChannel.Phone,
    [FirebaseChannel.Tab]: AppChannel.Tab,
}
